(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[586],{

/***/ 46554:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signature/pdf-tools/compress-pdf",
      function () {
        return __webpack_require__(35145);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 35145:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6154);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(10411);
/* harmony import */ var _signature_module_css__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_signature_module_css__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_icons_fa6__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70231);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);
/* harmony import */ var _components_SignaturePopup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86318);
/* harmony import */ var _components_PdfTools_UploadFile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86297);
/* harmony import */ var _components_PdfTools_Steps__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2561);
/* harmony import */ var _components_PdfTools_WhyChooseBolosign__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(80383);
/* harmony import */ var _components_PdfTools_PricingCards__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23278);
/* harmony import */ var _components_PdfTools_TryBolosign__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(86658);
/* harmony import */ var _components_PdfTools_OtherPdfTools__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41441);
/* harmony import */ var _components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86585);
/* harmony import */ var react_icons_lu__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1451);
/* harmony import */ var react_icons_fa__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(89583);


















const resolutions = [
    72,
    100,
    144,
    200,
    300,
    720
];
const steps = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lu__WEBPACK_IMPORTED_MODULE_12__/* .LuUpload */ .oSY, {}),
        title: "Upload Your File",
        description: "Drag and Drop your file into the compressor or simply click the upload button and select a document from your local storage."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa__WEBPACK_IMPORTED_MODULE_13__/* .FaCompressArrowsAlt */ .Al0, {}),
        title: "Compress your file",
        description: "Click on 'Compress' to initiate the PDF compression process. Our tool ensures that your PDF is compressed without compromising on quality."
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_lu__WEBPACK_IMPORTED_MODULE_12__/* .LuDownload */ .$0x, {}),
        title: "Download PDF",
        description: "Once the PDF compression is complete, download your reduced PDF files from your browser."
    }
];
const reasons = [
    {
        image: "drag_and_drop_upload.png",
        title: "Drag-and-drop upload",
        description: "Simply drag the file from your device to our Compress PDF tool to start the process instantly."
    },
    {
        image: "file_deletion_policy.png",
        title: "File Deletion Policy",
        description: "We prioritize your privacy. All uploaded files are automatically deleted after conversion."
    },
    {
        image: "cross_platform_compatibility.png",
        title: "Cross-Platform Compatibility",
        description: "Access our tool from any device, whether you're using a desktop, tablet, or smartphone."
    },
    {
        image: "secure_encryption.png",
        title: "Secure encryption",
        description: "We use advanced encryption to ensure your files remain secure during the PDF compression process."
    }
];
const faqData = [
    {
        faqQuestion: "How do I reduce the size of a PDF file?",
        faqAnswer: "Use our PDF compress tool by uploading your file and clicking ‘Compress’."
    },
    {
        faqQuestion: "What does a PDF compressor mean?",
        faqAnswer: "A PDF compressor reduces the file size of a PDF without compromising its quality."
    },
    {
        faqQuestion: "How do I reduce PDF to 100kb?",
        faqAnswer: "Upload your file to our PDF compress tool and select the desired file size."
    },
    {
        faqQuestion: "Is it bad to compress PDFs?",
        faqAnswer: "No, compressing PDFs helps save storage space and makes them easier to share."
    }
];
function CompressPdf() {
    const [file, setFile] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const [resolution, setResolution] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(72);
    const [downloading, setDownloading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [error, setError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [signaturePopup, setSignaturePopup] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const scrollToPreview = ()=>{
        const element = document.querySelector(".resolution-field");
        if (element) {
            element.scrollIntoView({
                behavior: "smooth"
            });
        }
    };
    const handleFileUpload = (files)=>{
        setFile(files[0]);
        setError("");
        if (files) {
            scrollToPreview();
        }
    };
    const compressPdf = async ()=>{
        setError("");
        if (!file) {
            setError("Please choose a file");
            return;
        }
        if (file.name.split(".").pop() !== "pdf") {
            setError("Please choose a pdf file");
            return;
        }
        if (!resolution || resolution === NaN) {
            setResolution(100);
        }
        if (file.size > 30000000) {
            setError("File Size is too large(>30MB)");
            return;
        }
        const formData = new FormData();
        formData.append("file", file);
        formData.append("resolution", resolution);
        try {
            setDownloading(true);
            const response = await axios__WEBPACK_IMPORTED_MODULE_14__/* ["default"].post */ .Z.post("".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_URL_POST, "compressPdf"), formData, {
                responseType: "blob"
            });
            // console.log(response)
            downloadFile(response.data);
        } catch (error) {
            setDownloading(false);
            if (error.response.data.type === "text/html") {
                const blobReader = new FileReader();
                blobReader.addEventListener("loadend", ()=>{
                    setError(blobReader.result);
                });
                blobReader.readAsText(error.response.data);
                return;
            }
            setError(error.response.data);
        }
    };
    const downloadFile = (blob)=>{
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "compressed.pdf";
        link.click();
        setDownloading(false);
        setTimeout(()=>{
            setSignaturePopup(true);
        }, 2000);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full mt-20 sm:mt-24",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        charSet: "utf-8"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Compress PDF Tool - BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Compress PDF Tool allows you to reduce the size of your PDF documents without losing quality."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "keywords",
                        content: "compress pdf, compress pdf online, compress pdf file, compress pdf document, compress pdf file online, compress pdf file free, compress pdf free, compress pdf online free, compress pdf boloforms, compress pdf tool, compress pdf tool online, compres pdf boloforms, compress pdf tool free, compress pdf tool online free, compress pdf tool boloforms, compress pdf tool boloforms online, compress pdf tool boloforms free, compress pdf tool boloforms online free, compress pdf tool boloforms free online, compress pdf tool boloforms free trial, compress pdf tool boloforms free download, compress pdf tool boloforms free download full version, compress pdf tool boloforms free download for windows 10, compress pdf tool boloforms free download for windows 7, compress pdf tool boloforms free download for windows 8, compress pdf tool boloforms free download for windows 8.1, compress pdf tool boloforms free download for windows xp"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "author",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1.0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/pdf-tools/compress-pdf"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: "Compress PDF Tool - BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: "Compress PDF Tool allows you to reduce the size of your PDF documents without losing quality."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/signature/pdf-tools/compress-pdf"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:width",
                        content: "1200"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:height",
                        content: "630"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image:alt",
                        content: "BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:locale",
                        content: "en_US"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:site",
                        content: "@BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:creator",
                        content: "@BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        content: "Compress PDF Tool - BoloForms"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: "Compress PDF Tool allows you to reduce the size of your PDF documents without losing quality."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/signature/pdf-tools/compress-pdf"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_UploadFile__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        heading: "Compress PDF Files with BoloSign for Free",
                        description: "Want to reduce the size of your PDF without sacrificing quality or format? We have a solution for you—use our PDF compress tool. Upload your file and let BoloSign's PDF compression services compress your PDF.",
                        bgColor: "bg-[#f5daf6]",
                        btnColor: "bg-[#d69eed]",
                        image: "compress-pdf.png",
                        handleFileUpload: handleFileUpload,
                        multipleFiles: false
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "resolution-field"
                    }),
                    file && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        id: "resolution-field",
                        className: "my-10",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center text-gray-900 text-xl mb-3",
                                children: [
                                    "Set Resolution for ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-lg",
                                        children: '"'.concat(file.name, '"')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-fit mx-auto flex justify-center flex-wrap mb-1 relative",
                                children: resolutions.map((res, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        onClick: ()=>setResolution(res),
                                        className: "w-[80px] text-center py-2 px-2 cursor-pointer hover:opacity-90 ".concat(resolution === res ? "text-violet-500 border border-violet-400 font-bold" : "text-gray-500 border border-gray-400"),
                                        children: res
                                    }, index))
                            }),
                            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-red-500 text-center text-xl",
                                children: error
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-full mt-10",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    onClick: compressPdf,
                                    className: "bg-[#f5daf6] mx-auto w-full sm:w-[350px] py-4 text-xl rounded-lg font-semibold text-gray-900 flex items-center justify-center gap-4 hover:opacity-90 border-2 border-gray-900",
                                    children: downloading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center text-gray-900 space-x-2 ".concat((_signature_module_css__WEBPACK_IMPORTED_MODULE_15___default().loader)),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "",
                                                children: "Compressing"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-2 h-2 bg-gray-900 rounded-full animate-bounce"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-2 h-2 bg-gray-900 rounded-full animate-bounce"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-2 h-2 bg-gray-900 rounded-full animate-bounce"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                        children: [
                                            "Compress PDF ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_fa6__WEBPACK_IMPORTED_MODULE_16__/* .FaFileZipper */ .I5w, {})
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full px-4 sm:px-8",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_Steps__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            heading: "How do you reduce the size of PDF with BoloSign?",
                            steps: steps
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-20",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_WhyChooseBolosign__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                            heading: "Why Choose BoloSign for Compressing PDFs?",
                            description: "Our free compressor tool has tons of handy features to make your PDF files smaller. You can do it in a very quick and reliable manner ensuring that your documents are ready when you need them. Also, we prioritize your privacy and data protection by processing and storing your documents securely.",
                            reasons: reasons
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_PricingCards__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            heading: "Looking for more than PDF tools?",
                            description: "Join 50,000+ teams who are already signing and accelerating their document workflow with BoloSign."
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_TryBolosign__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                            heading: "Try BoloSign Free for 7 Days!",
                            bgColor: "bg-[#f5daf6]"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full px-4 sm:px-8 mt-16 sm:mt-32",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_PdfTools_OtherPdfTools__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                            heading: "Other PDF Editing Tools",
                            description: "Free online PDF tools to merge, split, rotate, compress, convert, and many more.\nManage your daily PDF tasks with our online PDF tools."
                        })
                    }),
                    signaturePopup && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_SignaturePopup__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        onPopupClose: ()=>setSignaturePopup(false),
                        source: "MERGE_PDF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full max-w-screen-xl mx-auto px-4 sm:px-8 mt-16 sm:mt-32 flex flex-col gap-12",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-center font-bold leading-[45px] sm:leading-[55px] lg:leading-[70px] text-[36px] sm:text-[48px] lg:text-[60px]",
                                children: "Frequently Asked Questions"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "max-w-screen-lg mx-auto w-full flex flex-col gap-6",
                                children: faqData.map((faq, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Cards_FaqCard__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                        faqQuestion: faq.faqQuestion,
                                        faqAnswer: faq.faqAnswer
                                    }, index))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["default"] = (CompressPdf);


/***/ }),

/***/ 92703:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(50414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 45697:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(92703)();
}


/***/ }),

/***/ 50414:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2013,4617,7627,9570,3758,4599,2145,9774,2888,179], function() { return __webpack_exec__(46554); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);